"use client";
import { AppProgressBar } from "next-nprogress-bar";

export default function ProgressBar() {
  return (
    <AppProgressBar
      height="4px"
      color="rgb(249,115,22)"
      options={{ showSpinner: false }}
      shallowRouting
    />
  );
}
